import React from "react";
import { Link } from "react-router-dom";
import { useLang } from "../../context/LanguageContext";
import { Button } from "../ui/button";
import { ArrowRight } from "lucide-react";

export default function FinalCTA() {
  const { t } = useLang();
  return (
    <section
      id="final-cta"
      data-testid="final-cta-section"
      className="relative py-24 md:py-32 bg-[#0A0A0A] overflow-hidden"
    >
      <div className="absolute inset-0 pointer-events-none">
        <div className="absolute top-1/2 left-1/2 w-[800px] h-[800px] -translate-x-1/2 -translate-y-1/2 rounded-full bg-[#F2B705]/5 blur-3xl" />
      </div>

      <div className="relative max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <div className="flex items-center justify-center gap-3 mb-8">
          <div className="w-8 h-px bg-[#F2B705]" />
          <span className="label-gold">{t("finalCta.label")}</span>
          <div className="w-8 h-px bg-[#F2B705]" />
        </div>

        <h2 className="font-display text-4xl sm:text-5xl lg:text-6xl font-semibold text-white leading-[1.05] tracking-tight mb-8 max-w-4xl mx-auto">
          {t("finalCta.title")}
        </h2>

        <p className="text-neutral-400 text-base lg:text-lg leading-relaxed max-w-2xl mx-auto mb-12">
          {t("finalCta.body")}
        </p>

        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <Link to="/kontakt" data-testid="final-cta-primary">
            <Button
              size="lg"
              className="bg-[#F2B705] hover:bg-[#FFC933] text-[#0A0A0A] font-semibold rounded-sm px-10 py-6 text-base group"
            >
              {t("finalCta.cta1")}
              <ArrowRight className="ml-2 w-4 h-4 group-hover:translate-x-1 transition-transform" />
            </Button>
          </Link>
          <Link to="/kontakt" data-testid="final-cta-secondary">
            <Button
              size="lg"
              variant="outline"
              className="border-[#F2B705]/50 text-[#F2B705] hover:bg-[#F2B705]/10 hover:text-[#F2B705] rounded-sm px-10 py-6 text-base bg-transparent"
            >
              {t("finalCta.cta2")}
            </Button>
          </Link>
        </div>
      </div>
    </section>
  );
}
